import { createFileRoute, redirect } from "@tanstack/react-router";
import { LoginPage } from "@/auth/LoginPage";
import { getToken } from "@/lib/api";

export const Route = createFileRoute("/login")({
  validateSearch: (search: Record<string, unknown>) => ({
    intent: search.intent === "demo" ? "demo" as const : undefined,
  }),
  beforeLoad: ({ search }) => {
    if (!getToken()) return;
    if (search.intent === "demo") {
      throw redirect({ to: "/onboarding/setup", search: { mode: "demo" } });
    }
    throw redirect({ to: "/" });
  },
  component: LoginRoutePage,
});

function LoginRoutePage() {
  const search = Route.useSearch();
  return <LoginPage demoIntent={search.intent === "demo"} />;
}
